import React from 'react';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ChartLegend extends React.Component {
    render () {
        return (
            <div id="legendWindow" title={this.props.translate("Charts.LegendsToolTip")} style={{display: 'none'}}>
                <div className="section">
                    <div className="section-header collapsed" data-toggle="collapse" data-target="#negative">
                        <strong><Translate id="Charts.ExportShortcutOverview" /></strong>
                        <FontAwesomeIcon icon="angle-up" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                        <FontAwesomeIcon icon="angle-down" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                    </div>
                    <div id="negative" className="section-content collapse">
                        <table style={{width: '100%'}}>
                            <thead>
                                <tr>
                                    <th><Translate id="Charts.WarningTableHelpAbbreviation" /></th>
                                    <th><Translate id="Charts.WarningTableHelpDescription" /></th>
                                    <th><Translate id="Charts.WarningTableHelpSource" /></th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                </div>

                <div className="section">
                    <div className="section-header collapsed" data-toggle="collapse" data-target="#relations">
                        <strong><Translate id="Charts.WarningTableHelpAbbreviationTitle" /></strong>
                        <FontAwesomeIcon icon="angle-up" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                        <FontAwesomeIcon icon="angle-down" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                    </div>
                    <div id="relations" className="section-content collapse">
                        <table style={{width: '100%'}}>
                            <thead>
                                <tr>
                                    <th><Translate id="Charts.WarningTableHelpGroupName" /></th>
                                    <th><Translate id="Charts.WarningTableHelpAbbreviation" /></th>
                                </tr>
                            </thead>
                            <tbody id="tableRelationsShortcuts"></tbody>
                        </table>
                    </div>
                </div>

                <div id="section-semaphoreSK" className="section">
                    <div className="section-header collapsed" data-toggle="collapse" data-target="#semaphoreSK">
                        <strong><Translate id="Charts.SemaphoreTitleSK" /></strong>
                        <FontAwesomeIcon icon="angle-up" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                        <FontAwesomeIcon icon="angle-down" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                    </div>
                    <div id="semaphoreSK" className="section-content collapse">
                        <table style={{width: '100%'}}>
                            <thead>
                                <tr>
                                    <th><Translate id="Charts.SemaphoreCribis" /></th>
                                    <th><Translate id="Charts.SemaphoreNote" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreGrey"></span>
                                    </td>
                                    <td><Translate id="Charts.SemaphoreGreySK" /></td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreGreen"></span>
                                    </td>
                                    <td><Translate id="Charts.SemaphoreGreenSK" /></td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreYellow"></span>
                                    </td>
                                    <td>{this.props.translate("Charts.SemaphoreYellowSK").replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreRed"></span>
                                    </td>
                                    <td>{this.props.translate("Charts.SemaphoreRedSK").replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="section-semaphoreCZ" className="section">
                    <div className="section-header collapsed" data-toggle="collapse" data-target="#semaphoreCZ">
                        <strong><Translate id="Charts.SemaphoreTitleCZ" /></strong>
                        <FontAwesomeIcon icon="angle-up" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                        <FontAwesomeIcon icon="angle-down" style={{marginRight: '5px',marginTop: '2px',float:'right'}}/>
                    </div>
                    <div id="semaphoreCZ" className="section-content collapse">
                        <table style={{width: '100%'}}>
                            <thead>
                                <tr>
                                    <th><Translate id="Charts.SemaphoreCribis" /></th>
                                    <th><Translate id="Charts.SemaphoreNote" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreGrey"></span>
                                    </td>
                                    <td><Translate id="Charts.SemaphoreGreyCZ" /></td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreGreen"></span>
                                    </td>
                                    <td><Translate id="Charts.SemaphoreGreenCZ" /></td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreYellow"></span>
                                    </td>
                                    <td>{this.props.translate("Charts.SemaphoreYellowCZ").replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                        <span className="semaphore-img semaphoreRed"></span>
                                    </td>
                                    <td>{this.props.translate("Charts.SemaphoreRedCZ").replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withLocalize(ChartLegend));
